module.exports = __webpack_public_path__ + "4eeb9a77b7081226a21867a0cd4e20fa.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/GoldenCityapp.jpg
// module id = 705
// module chunks = 0